import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 19a1 1 0 0 1 0 2h-16a1 1 0 0 1 0 -2z","key":"svg-0"}],["path",{"d":"M13 3a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-1"}]]

const IconLayoutAlignBottomFilled = createReactComponent('filled', 'layout-align-bottom-filled', 'LayoutAlignBottomFilled', __iconNode);

export default IconLayoutAlignBottomFilled;